import React from "react";
import dayjs from "dayjs";
import { DataTable, Column, Cell, Text, Badge } from "@tv2no/ui-react";

export const ImportLogTable = ({ log }) => {
    return (
        <DataTable rows={log}>
            <Column
                cell={({ row }) => (
                    <Cell>
                        <Text color="base">{dayjs(row.created).format("HH:mm:ss")}</Text>
                    </Cell>
                )}
            >
                Tid
            </Column>
            <Column
                cell={({ row }) => (
                    <Cell>
                        <Badge
                            fill
                            color={
                                row.level === "INFO"
                                    ? "info"
                                    : row.level === "WARN"
                                      ? "warning"
                                      : "error"
                            }
                        >
                            {row.level}
                        </Badge>
                    </Cell>
                )}
            >
                Nivå
            </Column>
            <Column cell={({ row }) => <Cell>{row.message}</Cell>}>Melding</Column>
        </DataTable>
    );
};
